import { render, staticRenderFns } from "./leavePopupDetail.vue?vue&type=template&id=4930b3d2"
import script from "./leavePopupDetail.vue?vue&type=script&lang=js"
export * from "./leavePopupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports